<div (click)="click.emit()" role="button" class="btn-rounded primary-gradient-bg-100 padding-1sm font-4 rounded-2 text-center">
    <div class="btn-rounded rounded-2 px-2 py-2">
        <ng-content></ng-content>
    </div>
</div>